// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { uploadTokenId } from './UploadToken';
import { invLocationId } from './InvLocation';
import { operatorId } from './Operator';
import { z } from 'zod';
export const invIntakeSessionId = (z.number());
export const invIntakeSession = z.object({
    id: invIntakeSessionId,
    upload_token_id: uploadTokenId.nullable(),
    location_id: invLocationId.nullable(),
    closed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    upload_token: z.string().nullable(),
});
export const invIntakeSessionInitializer = z.object({
    id: invIntakeSessionId.optional(),
    upload_token_id: uploadTokenId.optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    upload_token: z.string().optional().nullable(),
});
export const invIntakeSessionMutator = z.object({
    id: invIntakeSessionId.optional(),
    upload_token_id: uploadTokenId.optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    upload_token: z.string().optional().nullable(),
});
//# sourceMappingURL=InvIntakeSession.js.map